<template>
  <div class="body-div">
    <button v-on:click="showLiveVikiCR = false" :class={selected:!showLiveVikiCR}>LiveVikiDeposits</button>
    <button v-on:click="showLiveVikiCR = true" :class={selected:showLiveVikiCR}>LiveVikiCR</button>
    <live-viki-c-r v-if="showLiveVikiCR"></live-viki-c-r>
    <div class="top-div" v-show="!showLiveVikiCR">
      <div class="table" >

        <div>
          <div
            class="time-messages"
            v-for="(value, time) in liveStats"
            v-bind:key="time"
          >
            <span class="live-data" v-if="time == 9">
              <span>The time now is: {{ time }}:00</span>
              <span
                >Deposits until now: {{ value.deposits_today_until_now }}
              </span>
              <span
                >Average deposits until now:
                {{ value.deposits_average_per_hour }}</span
              >
              <span v-if="value.deposits_yesterday >= value.deposits_average">
                <span>
                  Great job yesterday you all did
                  {{ value.deposits_yesterday }} Sales, lets' make the same
                  today!
                </span>
              </span>
              <span v-else>
                <span>
                  I do not want to remember Previous day that we did
                  {{ value.deposits_yesterday }}
                  .. Today we are starting fresh - Good Luck
                </span>
              </span>
            </span>
            <span class="live-data" v-if="time == 10">
              <span>The time now is: {{ time }}:00</span>
              <span
                >Deposits until now: {{ value.deposits_today_until_now }}
              </span>
              <span
                >Average deposits until now:
                {{ value.deposits_average_per_hour }}</span
              >
              <span
                v-if="
                  value.deposits_today_until_now >=
                    value.deposits_average_per_hour
                "
              >
                <span>
                  It's now 10:00 We are off a great start, we already have
                  {{ value.deposits_today_until_now }}
                </span>
              </span>
              <span v-else>
                <span>
                  It's now 10:00 The day already started, but we are still not
                  moving
                </span>
              </span>
            </span>
            <span class="live-data" v-if="time == 12">
              <span>The time now is: {{ time }}:00</span>
              <span
                >Deposits until now: {{ value.deposits_today_until_now }}
              </span>
              <span
                >Average deposits until now:
                {{ value.deposits_average_per_hour }}</span
              >
              <span
                v-if="
                  value.deposits_today_until_now >=
                    value.deposits_average_per_hour
                "
              >
                <span>
                  It's now 12:00 Great job we are on the right path to success
                </span>
              </span>
              <span v-else>
                <span>
                  It's now 12:00 Guys, wake up! you are making me look bad in
                  front of my Creator :(
                </span>
              </span>
            </span>
            <span class="live-data" v-if="time == 15">
              <span>The time now is: {{ time }}:00</span>
              <span
                >Deposits until now: {{ value.deposits_today_until_now }}
              </span>
              <span
                >Average deposits until now:
                {{ value.deposits_average_per_hour }}</span
              >
              <span
                v-if="
                  value.deposits_today_until_now >=
                    value.deposits_average_per_hour
                "
              >
                <span>
                  It's now 15:00 This is the way to do it, keep the locomotive
                  going
                </span>
              </span>
              <span v-else>
                <span>
                  It's now 15:00 You are just ruing me, with all the powers that
                  I have to assist you to make a deposit, let's go team wakeup!
                </span>
              </span>
            </span>
            <span class="live-data" v-if="time == 18">
              <span>The time now is: {{ time }}:00</span>
              <span
                >Deposits until now: {{ value.deposits_today_until_now }}
              </span>
              <span
                >Average deposits until now:
                {{ value.deposits_average_per_hour }}</span
              >
              <span
                v-if="
                  value.deposits_today_until_now >=
                    value.deposits_average_per_hour
                "
              >
                <span>
                  It's now 18:00 This the way aha aha I like it aha aha!
                </span>
              </span>
              <span v-else>
                <span>
                  It's now 18:00 I'm not getting angry... noooooo.. not at
                  all... but do not forget I have the power to turn off
                  electricity in the building, don't make my systems explode,
                  make sales
                </span>
              </span>
            </span>
            <span class="live-data" v-if="time == 21">
              <span>The time now is: {{ time }}:00</span>
              <span
                >Deposits until now: {{ value.deposits_today_until_now }}
              </span>
              <span
                >Average deposits until now:
                {{ value.deposits_average_per_hour }}</span
              >
              <span
                v-if="
                  value.deposits_today_until_now >=
                    value.deposits_average_per_hour
                "
              >
                <span>
                  Amazing Job Today!! You guys are the best! I'm so glad that I
                  was born to assist you.
                </span>
              </span>
              <span v-else>
                <span>
                  well... you killed me today, my Creator now will need to
                  delete my memory...
                </span>
              </span>
            </span>
            <hr />
          </div>
        </div>
      </div>
      <div class="loader-div" v-if="liveStatsBusy">
        <!--        <loader :size="'8px'"></loader>-->
        <span class="insteadLoader"
          >CREATING REPORT ,PLEASE WAIT
          <div class="snippet" data-title=".dot-flashing">
            <div class="stage">
              <div class="dot-flashing"></div>
            </div>
          </div>
        </span>
      </div>
      <!--      <loader class="loader" :size="'8px'" v-if="liveStatsBusy"></loader>-->
    </div>
    <div class="bottom-div" v-if="false">
      <span v-if="false"
        >Forbidden, You are not authorized to see this data</span
      >
      <div class="fab"><span class="fas fa-file-csv"></span></div>
    </div>
  </div>
</template>

<script>
import Loader from "../../../../../main/misc.main/loader/Loader";
import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../../helpers/api/request";
import LiveVikiCR from "../../liveVikiCR.stats/containers/liveVikiCR.container";
export default {
  name: "LiveVikiDeposits.container",
   components: { LiveVikiCR },
  data() {
    return {
      showLiveVikiCR:false,
      liveStatsBusy: false,
      liveStats: [],
      liveStatsMessages: {
        9: {
          above:
            "Great Job Yesterday for achieving [ amount of deposit ], i'm so proud of you, let's start a new fight today!",
          below: ""
        },
        10: {
          above: "",
          below: ""
        },
        12: {
          above: "",
          below: ""
        },
        15: {
          above: "",
          below: ""
        },
        18: {
          above: "",
          below: ""
        },
        21: {
          above: "",
          below: ""
        }
      }
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", ["dictionaries", "salesPersonList"])
  },
  mounted() {
    this.getLiveStats();
  },
  created() {},
  methods: {
    async updateDBWithLiveStats() {
      if (this.checkPermissions(this.auth, [1, 2, 3, 4, 12])) {
        try {
          await apiClientCreator(`live_stats/deposit_db_stats`).get("");
        } catch (e) {}
      }
    },
    async getLiveStats() {
      this.liveStats = [];
      if (
        !this.liveStatsBusy &&
        this.checkPermissions(this.auth, [1, 2, 3, 4, 12])
      ) {
        try {
          this.liveStatsBusy = true;
          const res = await apiClientCreator(
            `live_stats/deposit_live_stats`
          ).get("");
          this.liveStats = res.data;
          this.liveStatsBusy = false;
        } catch (e) {}
      }
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    }
  }
};
</script>

<style scoped>
.body-div {
  padding: 4px 5px 1px 5px;
}
.top-div {
  width: 100%;
  height: max-content;
  margin: auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
}
.bottom-div {
  width: 100%;
  height: 650px;
  overflow-y: scroll;
  margin: 5px auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
  position: relative;
}
.fab {
  background-color: transparent;
  padding: 0;
  font-size: 30px;
  line-height: 30px;
  color: green;
  text-align: center;
  position: absolute;
  right: 10px;
  bottom: 10px;
  border-radius: 20%;
  transition: all 0.1s ease-in-out;
  cursor: pointer;
}

.fab:hover {
  box-shadow: 0 5px 11px 0 #666;
  transform: scale(1.05);
}
.table {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}
.table td {
  padding: 0.3em 0;
}
.table table {
  font-size: 13px;
  width: 1500px;
  margin: 3em 0;
}
.table thead {
  border-bottom: solid 2px #eff3f6;
}
.table tfoot {
  border-top: solid 2px #eff3f6;
  color: red;
}
.table th {
  text-align: center;
}
.text-center {
  font-weight: bold;
}
.loader {
  left: 0;
  right: 0;
}
.live-data {
  display: flex;
  flex-direction: column;
}
.time-messages {
  padding: 1em;
}

/**
 * ==============================================
 * Dot Flashing
 * ==============================================
 */
.dot-flashing {
  position: relative;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite linear alternate;
  animation-delay: 0.5s;
}

.dot-flashing::before,
.dot-flashing::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}

.dot-flashing::before {
  left: -15px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 0s;
}

.dot-flashing::after {
  left: 15px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 1s;
}

@keyframes dotFlashing {
  0% {
    background-color: red;
  }
  50%,
  100% {
    background-color: #ebe6ff;
  }
}
.stage {
  position: absolute;
  left: 110%;
  top: 48%;
}
.insteadLoader {
  color: red;
  position: absolute;
  left: 45%;
  top: 80px;
}
.selected{
  background-color: #808080c7;
  color: white;
}
</style>
